<template>
  <div :style="{height:`${this.window.height}px`}" class="main-wrapper">
    <div class="main-left">
      <sidebar-menu
        @toggle-collapse="onToggleCollapse"
        @item-click="onItemClick"
        width="250px"
        height="100%"
        widthCollapsed="50px"
        :relative="true"
        :menu="menu"
        :exactPath="false"
        :collapsed="collasped"
        :disableHover="true"
      />
    </div>
    <div class="main-right">
      <Header />
      <div v-if="!collasped && window.width<1000" @click="onToggleCollapse" class="right-overlay"></div>
      <div :class="!collasped?`right-body full`:'right-body'">
        <div class="toasts-wrapper">
          <template v-for="(toast,index) in toastsArray">
            <Toast
              :key="index"
              :title="toast.title"
              :message="toast.message"
              :variant="toast.variant"
              :index="index"
              :timer="5"
            />
          </template>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
import { auth } from "../Firebase/firebase";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import Header from "../pages/components/Header";
import Toast from "../pages/components/Toast";
export default {
  components: {
    SidebarMenu,
    Header,
    Toast
  },
  data() {
    return {
      collasped: false,
      count: 34,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    async fetchUserProfile() {
      const userProfile = await this.$store.dispatch(
        "Auth/fetchUserProfile",
        auth.currentUser
      );
      return userProfile;
    },
    async fetchNotificationsCount() {
      const count = await this.$store.dispatch("Menu/fetchNotificationsCount");
      return count;
    },
    onToggleCollapse() {
      this.collasped = !this.collasped;
    },
    onItemClick(event, item, node) {
      switch (item.title) {
        case "Logout":
          return this.logout();
        default:
          return;
      }
    },
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.collasped = window.innerWidth < 1000 ? true : false;
    }
  },
  computed: {
    toastsArray() {
      return this.$store.state.ToastArray;
    },
    menu() {
      return [
        /* {
          header: true,
          title: "Main Navigation",
          hiddenOnCollapse: true
        }, */
        {
          href: "/dashboard",
          title: "Menus",
          icon: " fa fa-bars"
        },
        {
          
          title: "Products",
          icon: " fa fa-bars",
          child: [
            {
              href: "/dashboard/categories",
              title: "Categories",
              icon: " fa fa-bars"
            },
            {
              href: "/dashboard/items",
              title: "Items",
              icon: " fa fa-bars"
            }
          ]
        },
        {
          href: "/dashboard/orders",
          title: "Orders",
          icon: "fas fa-inbox"
        },

        {
          href: "/dashboard/user/profile",
          title: "Profile",
          icon: "fa fa-user"
        },
        {
          href: "/dashboard/user/notifications",
          title: "Notifications",
          icon: "fa fa-bell",
          badge: {
            text: this.notificationsCount.total,
            class: "vsm--badge_default"
            // attributes: {}
            // element: 'span'
          }
        },

        {
          title: "Logout",
          icon: "fa fa-power-off"
        }
      ];
    },
    notificationsCount() {
      return this.$store.state.Menu.notificationsCount
        ? this.$store.state.Menu.notificationsCount
        : { total: 0 };
    }
  },
  mounted() {
    this.fetchUserProfile().then(response => {
      if (!response.fcmToken) {
        this.$store.dispatch("Auth/getFcmToken", auth.currentUser.uid);
      }
    });
    this.fetchNotificationsCount();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style>
.main-wrapper {
  display: flex;
}

.v-sidebar-menu .vsm--scroll-wrapper {
  width: 250px;
}

.vsm_collapsed .vsm--scroll-wrapper {
  max-width: 67px;
}
.main-right {
  width: 100%;
  overflow-y: auto;
  background: #e5e5e5;
  position: relative;
}
.main-right .right-body {
  padding: 0 20px;
  position: relative;
}

.toasts-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 30px;
  z-index: 3;
}

.right-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00000087;
  :5000 ;
  z-index: 5;
}

@media screen and (max-width: 1000px) {
  .v-sidebar-menu.vsm_expanded.vsm_relative {
    position: absolute;
  }
  .right-body.full {
    margin-left: 50px;
    position: relative;
  }
}
</style>